import React from "react";
import ProviderSelectGrid from "../components/ProviderSelectGrid";

const CreditCardSelect = () => (
  <ProviderSelectGrid
    service="CCBILL"
    title="Select credit card bill provider"
    description="Choose an active provider first. The selected provider is used for fetch and pay."
    breadcrumbs={[
      { label: "Dashboard", to: "/dashboard" },
      { label: "CC Bill Payment" },
    ]}
    fallbackPath="/new-payment"
  />
);

export default CreditCardSelect;
